import {
  FIELD_TYPES, DEFAULT_IMPLIED_CONSENT,
  DEFAULT_IMPLIED_PHONE_CONSENT_KEY,
  LEGACY_GDPR_SETTINGS,
} from 'utils/constants';
import { shouldIncludeImpliedConsent } from 'utils/editorDefaultStates';

const _buildPhoneConfig = (gdprSetting) => (
  {
    includeImpliedConsent: shouldIncludeImpliedConsent(gdprSetting),
    impliedConsentData: [
      {
        ...DEFAULT_IMPLIED_CONSENT,
        key: DEFAULT_IMPLIED_PHONE_CONSENT_KEY,
      },
    ],
  }
);

function fromGQL(obj, gdprSetting) {

  // This is necessary to migrate existing "text" phone field types to the "phone" field type
  const { value, condition: oldCondition, ...returnableField } = obj;
  const type = FIELD_TYPES.PHONE;

  // When the phone field has already impliedConsentData, we need to keep it,
  // otherwise we need to add the default implied consent data
  const phoneConfig = value?.impliedConsentData ? value : _buildPhoneConfig(gdprSetting);

  const keepOldCondition = LEGACY_GDPR_SETTINGS.includes(gdprSetting) || !oldCondition?.startsWith('optional if');
  const condition = keepOldCondition ? oldCondition : '';

  return { ...returnableField, type, editors: { phoneConfig }, condition };
}

function overrideFromGQL(obj) {
  const { value, ...returnableField } = obj;
  return { ...returnableField, editors: { phoneConfig: value } };
}

function toGQL(opts, gdprSetting) {
  const phoneConfig = {
    ...opts.editors.phoneConfig,
    includeImpliedConsent: shouldIncludeImpliedConsent(gdprSetting),
  };

  return { value: phoneConfig };
}

function overrideToGQL(opts) {
  return { value: opts.editors.phoneConfig };
}

export default {
  fromGQL,
  overrideFromGQL,
  toGQL,
  overrideToGQL,
};
